import React from 'react';
import delhigovt from '../static/delhigovt.svg';
import Footer from './Footer';
import infographics from "../static/delhi-covid-infographics.png";
import infographics1 from "../static/delhi-covid-infographics1.svg";
import OtherLinks from "./OtherLinks";
import ShareButtons from "./ShareButtons";


// eslint-disable-next-line react/prefer-stateless-function
class About extends React.Component {
  componentDidMount(){
  window.scrollTo(0,0);
}
  render() {
    return (
      <div>
        <main>
          <div className="maintitlebar"><h1>Infographics</h1><img src={delhigovt} style={{ height: '70px' }} alt="delhi government logo" /></div>
          <div id="main--sections">
            <div id="infographics">
              <div className='infographic'>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://nctdelhi.blob.core.windows.net/nctdelhi/ProtocolsToFollow1.pdf"
                >
                  <img className='infographic--image' src={infographics} />
                </a>
                <ShareButtons url={`${window.location.protocol}//${window.location.host}${infographics}`} />
              </div>
                <div className='infographic'>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://nctdelhi.blob.core.windows.net/nctdelhi/ProtocolsToFollow.pdf"
                  >
                    <img className='infographic--image' src={infographics1} />
                    <ShareButtons url={`${window.location.protocol}//${window.location.host}${infographics}`} />
                  </a>
                </div>
              </div>
            <div>
              <OtherLinks showInfographics={false} />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}

export default About;
